export default __webpack_public_path__ + "src/static/img/png/v2/solutions/section-two-arch-left.png";